import fs from 'node:fs';
import path from 'node:path';

export const RESOLVE_CACHE_MAX = 4096;

export type ResolvedFileCacheEntry = {
  path: string;
  size: number;
  mtimeMs: number;
};

const resolveCache = new Map<string, ResolvedFileCacheEntry>();

export function resolveCacheKey(sessionParentPath: string, relativePath: string): string {
  return `${sessionParentPath}\0${relativePath}`;
}

export function pathStaysUnderParent(filePath: string, sessionParentPath: string): boolean {
  const parent = path.resolve(sessionParentPath);
  const resolved = path.resolve(filePath);
  return resolved === parent || resolved.startsWith(`${parent}${path.sep}`);
}

export async function statMatchesCache(entry: ResolvedFileCacheEntry): Promise<boolean> {
  return statMatchesCacheSync(entry);
}

export function statMatchesCacheSync(entry: ResolvedFileCacheEntry): boolean {
  try {
    const stat = fs.statSync(entry.path);
    return stat.isFile() && stat.mtimeMs === entry.mtimeMs && stat.size === entry.size;
  } catch {
    return false;
  }
}

export function getResolveCacheEntry(cacheKey: string): ResolvedFileCacheEntry | undefined {
  return resolveCache.get(cacheKey);
}

export function deleteResolveCacheEntry(cacheKey: string): void {
  resolveCache.delete(cacheKey);
}

export function storeResolveCacheEntry(cacheKey: string, entry: ResolvedFileCacheEntry): ResolvedFileCacheEntry {
  if (resolveCache.size >= RESOLVE_CACHE_MAX) resolveCache.clear();
  resolveCache.set(cacheKey, entry);
  return entry;
}

export function hasResolveCacheEntry(cacheKey: string): boolean {
  return resolveCache.has(cacheKey);
}

/** @internal Test helper. */
export function resetResolveFileCacheForTests(): void {
  resolveCache.clear();
}
